// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"9b456986","221":"c1fad73d","379":"22c1e14a","390":"bf195032","400":"5cbdf9f7","413":"a8971030","728":"c3d7c730","752":"118a5f5a","852":"12984a91","903":"1e4f8616","912":"fd6639da","947":"78a5335e"}[chunkId] + ".chunk.js";
};